import { clearDataMemoryCache } from './dataApi';

const EXACT_KEYS = new Set([
  'sm_lang_local_users',
  'sm_lang_local_session',
  'sm_lang_guest_prefs',
  'sublingox_ui_lang',
  'xp_today',
  'xp_today_date',
  'xp_total',
  'xp_goal',
  'streak_count',
  'streak_last_day',
  'achievements_unlocked',
  'practice_sessions_count',
  'practice_review_asked',
]);

const KEY_PREFIXES = [
  'sm_lang_user_prefs_',
  'srs_',
  'learning_progress_v1_',
  'exercise_best_',
];

export function isAppOwnedStorageKey(key) {
  return EXACT_KEYS.has(key) || KEY_PREFIXES.some((prefix) => key.startsWith(prefix));
}

export function clearLocalUserData(storage = window.localStorage) {
  for (const key of Object.keys(storage)) {
    if (isAppOwnedStorageKey(key)) storage.removeItem(key);
  }
  clearDataMemoryCache();
  window.dispatchEvent(new CustomEvent('local-user-data-cleared'));
}
